module.exports = require('./helpers/bundle-url').getBundleURL('dWZnR') + "logo.c51670a8.svg";